<template>
  <div v-if="isVisible" class="p-4 my-4 bg-gray-100 border">
    <div class="flex">
      <div class="w-12 h-12">
        <i-heroicons-outline-exclamation-circle class="h-12 w-12 rotate-180" />
      </div>
      <span class="pt-3 pl-2 pr-12 text-2xl text-gray-700" v-html="label" />
    </div>

    <p class="mb-2 ml-14 pr-12 text-lg text-blue-900 text-black">
      <span v-if="messageIsHtml" v-html="message" />
      <span v-else> {{ message }}</span>
    </p>
  </div>
</template>

<script setup lang="ts">
// Props with defaults
withDefaults(
  defineProps<{
    label?: string;
    message?: string;
    messageIsHtml?: boolean;
    isVisible?: boolean;
  }>(),
  {
    label: "Error",
    message: "",
    messageIsHtml: false,
    isVisible: false,
  }
);
</script>
